const link = process.env.REACT_APP_SERVER_API_V2

const getContentUrl = () => `${link}/content`

export default getContentUrl
